const {Component} = require("react");
const Modal = require("components/modals/Modal");
const Form = require("components/forms/Form");
const Textarea = require("components/forms/Textarea");
const Load = require("components/mixins/Load");
const cartStore = require("stores/CartStore");

class RequestForm extends Form {

    /////////////////////////////////
    // Getters
    /////////////////////////////////

	get actionLabel() {
		return "Send besked";
	}

	get bookable() {
		return cartStore.attributes.bookable;
	}

    /////////////////////////////////
    // Handlers
    /////////////////////////////////

	send(form) {
		const data	= new FormData(form);
		const msg	= data.get('msg');

		return cartStore.sendMsg(msg);
	}

	handleSuccess(message) {
		this.setState({
			loading: false,
			message: message,
			errors: {}
		}, () => {
			if (typeof this.props.onSuccess === "function") {
				this.props.onSuccess();
			}
		});
	}

    /////////////////////////////////
    // Renders
    /////////////////////////////////

	renderHeader() {
		return (
			<div className="form-header top-bar"> 
				<p className="title">Send en besked til {this.bookable.nickname}</p> 
			</div> 
		);
	}

	renderBody() {
		return (
			<div className="form-body">
				<Textarea label="Din besked" className="full-width" name="msg" required={true} placeholder="Din besked..."/>
				<p>Vi gør opmærksom på, at det ikke er tilladt at foreslå kontakt uden om Clevermate platformen. Et brud på dette vil resultere i en udelukkelse af din profil. Din besked vil blive læst af en Clevermate support medarbejder, for at sikre at den overholder vores vilkår.</p>
			</div>
		);
	}

	renderFooter() {
		return (
			<div className="form-footer">
				<div className="actions">
					{this.renderActions()}
					<button type="submit" className="btn" disabled={this.loading}>{this.actionLabel}
						<Load></Load>
					</button>
				</div>
			</div>
		);
	 }
}

class ChatRequest extends Component {

	close = () => {
		this.modal.close();
	}

	render() {
		return (
			<div className="cta">
				<button className="btn" onClick={() => this.modal.open()} >
					Send besked
				</button>

				<Modal ref={el => this.modal = el}>
					<section className="request-booking">
						<RequestForm onSuccess={this.close} />
					</section>
				</Modal>
			</div>
		);
	}
}

module.exports = ChatRequest;



// WEBPACK FOOTER //
// ./resources/js/components/checkout/ChatRequest.js